/**
 * bzy-scroll-restore.js
 * Banzayak Fashion — Back button scroll position restore
 * Saves scroll position before leaving collection page,
 * restores it when user comes back via browser back button.
 */
(function () {
  'use strict';

  var STORE_KEY = 'bzy_scroll_';

  function pageKey() {
    return STORE_KEY + window.location.pathname;
  }

  function isStorageOk() {
    try {
      sessionStorage.setItem('__t', '1');
      sessionStorage.removeItem('__t');
      return true;
    } catch (e) {
      return false;
    }
  }

  if (!isStorageOk()) return;

  /* Save scroll on every scroll (throttled) */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      try {
        sessionStorage.setItem(pageKey(), window.scrollY);
      } catch (e) {}
      ticking = false;
    });
  }, { passive: true });

  /* Restore scroll if navigated back */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    try {
      var saved = sessionStorage.getItem(pageKey());
      if (saved !== null) {
        window.scrollTo({ top: parseInt(saved, 10), behavior: 'instant' });
      }
    } catch (e) {}
  });

  /* Also restore on DOMContentLoaded for bfcache-less browsers */
  if (performance && performance.navigation && performance.navigation.type === 2) {
    document.addEventListener('DOMContentLoaded', function () {
      try {
        var saved = sessionStorage.getItem(pageKey());
        if (saved !== null) {
          window.scrollTo({ top: parseInt(saved, 10), behavior: 'instant' });
        }
      } catch (e) {}
    });
  }
})();
